// export const BASE_URL = "http://localhost:5000";
// export const BASE_URL = "https://trenova-server.onrender.com";
export const BASE_URL = "https://trenova-kluvj.ondigitalocean.app";

export const USERS_URL = "/api/user";
export const TEACHERS_URL = "/api/teacher";
export const LEARNERS_URL = "/api/learner";
export const COURSES_URL = "/api/course";
